import modules from './projects/index'

// Export our state, getters, actions, mutations, and modules.
export default {
  namespaced: true, modules
}
